import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBlocks: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconBlocks"><Path d="M10.25 20.25V7.25H6.75C5.09315 7.25 3.75 8.59315 3.75 10.25V13.75M3.75 13.75H16.75V17.25C16.75 18.9069 15.4069 20.25 13.75 20.25H6.75C5.09315 20.25 3.75 18.9069 3.75 17.25V13.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><Path d="M20.25 6.75C20.25 5.09315 18.9069 3.75 17.25 3.75H13.75V10.25H20.25V6.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconBlocks;
